/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DistanceUnit = {
    Mi: 'MI',
    Km: 'KM'
} as const;
export type DistanceUnit = typeof DistanceUnit[keyof typeof DistanceUnit];

